import React, { Suspense,useEffect } from 'react';
import logo from './logo.svg';
import './App.scss';
import { useTranslation, I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // 导入前面创建的 i18n 配置
import routes from './router/router';
import { BrowserRouter as Router, Routes, Route, useRoutes,Navigate, useLocation } from 'react-router-dom';
import { initWxShare } from './utils/wxShare';
import NavigationBar from './components/NavigationBar.jsx';
import MobileNavigationBar from './components/MobileNavigationBar.jsx';
import Footer from './components/Footer.jsx';
import MobileFooter from './components/MobileFooter.js';
import { isMobile } from 'react-device-detect';

function WxShareSetup() {
  const location = useLocation()
  const { t } = useTranslation()
  useEffect(() => {
    const siteName = t('northBundForum')
    const matched = routes.find(r => {
      if (r.path.includes(':')) return false
      return location.pathname === r.path || location.pathname === r.path + '/'
    })
    const share = matched?.share || {}
    initWxShare({
      title: share.title ? `${share.title} - ${siteName}` : siteName,
      desc: share.desc || siteName,
    })
  }, [location.pathname])
  return null
}

function App() {
    if(!localStorage.getItem('lang')){
      localStorage.setItem('lang','zh')
      window.location.reload()
    }

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <WxShareSetup />
        <div className="App pt-[70px] 2xl:min-w-[1440px] overflow-x-hidden" >
          {isMobile ? <MobileNavigationBar /> : <NavigationBar />}
          <div className="app-content">
            <Suspense fallback={<div>加载中...</div>}>
              <Routes>
                {routes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </div>
          {isMobile ? <MobileFooter /> : <Footer />}
        </div>
      </Router>
    </I18nextProvider>
  );
}

export default App;
